module.exports = "<span data-ng-message=required>*Required</span> <span data-ng-message=pattern>*valid email address required</span>";